import {Component, EventEmitter, Input, OnInit, OnDestroy, Output} from '@angular/core';
import {ShipmentTypes} from '@store/reducers/shipments.reducer';
import {ShipmentPageSelect, ShipmentSelect} from '@store/actions/shipments.action';
import {AppState} from '@store/reducers';
import {Store} from '@ngrx/store';
import {Subject} from 'rxjs/Subject';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-shipment-table',
  template: `
    <app-table
      [rows]="this.rows"
      [data]="data"
      [checkboxSign]="checkboxSign"
      [deleteSign]="deleteSign"
      (deleteElement)="handleDelete($event)"
      (selectAll)="handleSelectAll($event)"
      (clickCheckbox)="handleClickCheckbox($event)"
      (selectRow)="handleSelectRow($event)"
      [isAllSelected]="false"
    >
    </app-table>
    <app-paginator
      [currentPage]="currentPage"
      [length]="totalShipmentsLength"
      [pageSize]="currentPageSize"
      (handleChangePage)="handleChangePage($event)"></app-paginator>
  `,
})

export class ShipmentTableComponent implements OnInit, OnDestroy {

  private unsubscribe: Subject<void> = new Subject();

  @Input() shipmentType: ShipmentTypes;
  @Input() rows: any;
  @Input() data: any;
  @Input() checkboxSign: boolean;
  @Input() deleteSign: boolean;
  @Input() totalShipmentsLength: number;
  @Input() currentPageSize: number;
  @Input() currentPage: number;

  @Output() changePage: EventEmitter<number> = new EventEmitter<number>();
  @Output() selectRow: EventEmitter<number> = new EventEmitter<number>();
  @Output() deleteElement: EventEmitter<number> = new EventEmitter<number>();

  private showReferenceColumn = false;

  constructor(
    private store: Store<AppState>,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    if (this.rows.length > 0) {
      for (const item of this.data) {
        // console.log(item);
        if (this.notEmpty(item.reference)) {
          this.rows.unshift(
            {label: this.translate.instant('account.section.shipment.saved.table.headerReference'), value: 'reference'}
          );
          break;
        }
      }
    }
  }

  notEmpty(value) {
    return value !== undefined && value !== null && value !== '' ? true : false;
  }


  handleDelete(id) {
    this.deleteElement.emit(id);
  }

  handleSelectAll(isSelected) {
    this.store.dispatch(new ShipmentPageSelect({
      current_page_size: this.currentPageSize,
      current_page: this.currentPage,
      type: this.shipmentType,
      isSelected,
    }));
  }

  handleSelectRow(id) {
    this.selectRow.emit(id);
  }

  handleClickCheckbox({id, isSelected}) {
    this.store.dispatch(new ShipmentSelect({
      current_page_size: this.currentPageSize,
      current_page: this.currentPage,
      type: this.shipmentType,
      id,
      isSelected
    }));
  }

  handleChangePage(currentPage) {
    this.changePage.emit(currentPage);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shipments/components/shipment-table/shipment-table.component.ts